import * as Actions from '../actions'
import * as Validation from '../validation'
import { LoftServices } from '../../../types/loft'

Actions.withOperationName(Actions)
Actions.withOperationName(Validation)

export default [
  Actions.startProgress,
  Actions.setMessageIds,
  Actions.setSession,
  Validation.throwOnInvalidSession,
  Actions.configureGateway,
  Actions.awaitAsync('me', ({ gateway }: LoftServices) => gateway.me.get()),
  Actions.setUserLocale,
  Actions.setTracingContext,
  Actions.awaitAsync('calendarSettings', ({ gateway }: LoftServices) =>
    gateway.meetings.getCalendarSettings()
  ),
  Actions.chooseStrategy,
  Actions.updateProgress('preparing_message'),
]
